// src/components/common/SubscriptionDialog.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';

const SubscriptionDialog = ({ open, onClose, onSubscribe }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="subscribe-dialog-title">
      <DialogTitle id="subscribe-dialog-title">Subscription required</DialogTitle>
      <DialogContent>
        <Typography>
          You are currently on a free trial. Please subscribe to download reports and access premium features.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            if (onSubscribe) onSubscribe();
            else window.location.href = '/subscription';
          }}
        >
          Subscribe
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionDialog;
